import { Action } from '@canvas/model/permissions';

import { policyAction, type PersistentPolicy } from '../../policy-manager-types.ts';

export const canExport: PersistentPolicy = {
  id: 'can-export',
  type: 'persistent',
  rule: (state) => {
    const action = policyAction(Action.export);
    if (state.has(action)) {
      return { can: action };
    }
    return { cannot: action };
  },
};
